export default "__VITE_ASSET__483803e8__"